export const colors = {
  background: {
    default: '#fff',
    contrast: '#F2F2F3',
    hover: '#e7e7eb',
    // hover: 'rgba(0,0,0,0.08)',
    selected: '#F2F2F316',
    overlay: '#F2F2F310',
    primary: '#E8F5FC',
    critical: '#FFEDE5',
    warning: '#FFF7E6',
    success: '#EBFAF5'
  },

  border: {
    default: '#E5E5E6',
    contrast: '#D8D7DB',
    selected: '#1A96DA',
    focused: '#1A96DA',

    primary: '#C4E5F8',
    critical: '#FFD3C2',
    warning: '#FEEAB8',
    success: '#C6F0E2',

    decorative: {
      multi:
        'linear-gradient(90deg, #CE55B0 -8.33%, #F34DAC 7.29%, #F48E66 22.92%, #F0B832 38.54%, #B2CE37 54.17%, #63D7AF 69.79%, #1CC2DF 85.42%, #0580E6 101.04%)',
      flex: 'linear-gradient(133.89deg, #CE55B0 -33.9%, #F34DAC 20.49%, #F48E66 82.67%)',
      food: 'linear-gradient(133.75deg, #B2CE37 -14.4%, #63D7AF 84.08%)',
      utilities:
        'linear-gradient(135deg, #63D7AF 0%, #1CC2DF 50%, #0580E6 100%)',
      total: 'linear-gradient(132.26deg, #0580E6 -141.5%, #F34DAC 84.24%)'
    }
  },

  content: {
    default: '#363738',
    subdued: '#6D6C72',
    disabled: '#CAC8D0',
    placeholder: '#949399',

    primary: {
      default: '#1A96DA',
      strong: '#136D9F'
    },
    critical: {
      default: '#FF5A19',
      strong: '#CC3900'
    },
    warning: {
      default: '#FCB408',
      strong: '#BB8402'
    },
    success: {
      default: '#33C794',
      strong: '#25926D'
    },

    above: {
      primary: '#FFFFFF',
      secondary: '#1D1148',
      selected: '#FFFFFF',
      contrast: '#363738'
    }
  },

  interactive: {
    primary: {
      default: '#136D9F',
      hover: '#1A96DA',
      pressed: '#49B0E9',
      disabled: '#E5E5E6'
    },
    secondary: {
      default: 'rgba(0, 0, 0, 0.08)',
      hover: 'rgba(0, 0, 0, 0.16)',
      pressed: 'rgba(0, 0, 0, 0.24)',
      disabled: '#E5E5E6'
    },
    selected: {
      default: '#136D9F',
      hover: '#1A96DA',
      pressed: '#49B0E9',
      disabled: '#E5E5E6'
    },
    contrast: {
      default: '#ffffff',
      hover: '#ffffff',
      pressed: '#ffffff',
      disabled: '#ffffff'
    }
  },

  wallet: {
    meal: {
      content: {
        default: '#CC3900',
        selected: '#802400'
      },
      background: {
        default: '#FFEDE5',
        selected: '#FFD3C2'
      },
      decorative: '#FF5A19'
    },

    mobility: {
      content: {
        default: '#B10C6A',
        selected: '#730845'
      },
      background: {
        default: '#FDE7F4',
        selected: '#FBC1E2'
      },
      decorative: '#EF1090'
    },

    grocery: {
      content: {
        default: '#599726',
        selected: '#3C661A'
      },
      background: {
        default: '#F2FAEB',
        selected: '#D9F1C6'
      },
      decorative: '#79CC33'
    },

    health: {
      content: {
        default: '#136D9F',
        selected: '#0D4869'
      },
      background: {
        default: '#E8F5FC',
        selected: '#C4E5F8'
      },
      decorative: '#1A96DA'
    },

    education: {
      content: {
        default: '#633FD3',
        selected: '#4626A6'
      },
      background: {
        default: '#EEEAFA',
        selected: '#D3C9F3'
      },
      decorative: '#8061DB'
    }
  },

  /* **************************
          OLD TOKENS
  *************************** */

  gradient: {
    rainbow:
      '#ce55b0, #f34dac, #f48e66, #f0b832, #b2ce37, #63d7af, #1cc2df, #0580e6',
    pinkorange: '#ce55b0, #f34dac, #f48e66, #f0b832',
    pinkorange2:
      '#ce55b0 -3.05%, #f34dac 33.69%, #f48e66 68.77%, #f0b832 103.84%, #f0b832 103.84%',
    yellowgreen: '#f0b832, #b2ce37, #63d7af',
    yellowgreen2:
      '#f0b832 -6.55%, #b2ce37 38.88%, #63d7af 85.38%, #1cc2df 134.14%',
    greenblue: '#b2ce37, #63d7af, #1cc2df, #0580e6',
    blueorange: '#0580e6, #c853b3, #f34dac, #f48e66',

    pink: '#f34dac, #c853b3'
  }
} as const
